/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EligibleDirectoryContactUser
 */
export interface EligibleDirectoryContactUser {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    first_name: string;
    /**
     * 
     */
    last_name: string;
    /**
     * 
     */
    title?: string | null;
    /**
     * 
     */
    email?: string | null;
    /**
     * 
     */
    phone?: string | null;
}

/**
 * Check if a given object implements the EligibleDirectoryContactUser interface.
 */
export function instanceOfEligibleDirectoryContactUser(value: object): value is EligibleDirectoryContactUser {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    return true;
}

export function EligibleDirectoryContactUserFromJSON(json: any): EligibleDirectoryContactUser {
    return EligibleDirectoryContactUserFromJSONTyped(json, false);
}

export function EligibleDirectoryContactUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): EligibleDirectoryContactUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'title': json['title'] === undefined ? undefined : json['title'] === null ? null : json['title'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'phone': json['phone'] === undefined ? undefined : json['phone'] === null ? null : json['phone'],
    };
}

export function EligibleDirectoryContactUserToJSON(json: any): EligibleDirectoryContactUser {
    return EligibleDirectoryContactUserToJSONTyped(json, false);
}

export function EligibleDirectoryContactUserToJSONTyped(value?: EligibleDirectoryContactUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'title': value['title'],
        'email': value['email'],
        'phone': value['phone'],
    };
}

